<template>
	<div>
		<b-container class="container-project my-4 py-5 pt-xl-0">
			<h2 class="bolder">Mis Cotizaciones</h2>
			<p class="mt-4">Sigue el estado real de cada una de las cotizaciones que has realizado. Puedes elegir la que prefieras y reservar directamente tu próximo departamento.</p>
			<div>
				<b-overlay :show="loading" rounded="lg" spinner-variant="customer">
					<b-table style="min-height: 100px" striped hover responsive :items="items" id="quote-table" :per-page="perPage" :current-page="currentPage">
						<template #head(date)>Fecha</template>
						<template #head(asset)>Inmueble</template>
						<template #head(project)>Proyecto</template>
						<template #head(address)>Dirección</template>
						<template #head(quote)>Cotización</template>
						<template #head(see)>Ver</template>
						<template #head(reserve)>Reservar</template>
						<template #cell(date)="data">{{data.value | moment('DD-MM-YYYY')}}</template>
						<template #cell(quote)="data">{{data.value | numberFormat}}</template>
						<template #cell(see)="data">
							<b-button :href="data.value" target="_blank" size="sm" squared variant="argenta" class="my-2 my-sm-0" >VER</b-button>
						</template>
						<template #cell(reserve)="data">
							<span v-if="data.value.isBusiness">Reservada</span>
							<span v-else>
								<template v-if="data.value.isReserve">
									<span v-if="data.value.projectId == 4">Reservar con ejecutivo</span>
									<b-button v-else :href="data.value.link" target="_blank" size="sm" squared variant="argenta" class="my-2 my-sm-0" >RESERVAR</b-button>
								</template>
								<span v-else>Vencida</span>
							</span>
						</template>
					</b-table>
					<small><i>*Se muestran las últimas 30 cotizaciones realizadas en {{$store.state.customer_name}}</i></small>
						<b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" aria-controls="quote-table" squared align="center"
					></b-pagination>
				</b-overlay>
			</div>
		</b-container>

	</div>
</template>
<script>
	export default {
	name: 'myquotes',
    data() {
      return {
		loading: true,
		perPage: 10,
		currentPage: 1,
		items: []
      }
    },
	mounted() {
		let self = this;
		this.axios.get("quotes/").then(result => {
			self.loading = false;
			self.items = result.data.map(function(quote){
				let elem = {};
				elem['date']= quote.FECHA_COTIZ;
				elem['asset']= quote.quote_assets[0].asset.TIPO_BIEN+' '+quote.quote_assets[0].asset.NUM_BIEN;
				elem['project']= quote.project.NOM_PROYECTO;
				elem['address']= quote.project.CALLE+(quote.project.COMUNA.length > 0 ? ', '+quote.project.COMUNA : '');
				elem['quote']= quote.ID_COTIZACION;
				elem['see']= 'https://'+self.$store.state.customer+'.mobysuite.com/reports/quote/'+quote.HASH_DOCUMENTO+'/Cotizacion-'+quote.ID_COTIZACION+'.pdf';
				elem['reserve']= {isReserve: self.canReserve(quote), isBusiness: quote.NEGOCIO, link: 'https://reserva.mobysuite.com/'+self.$store.state.customer+'/proyecto/'+quote.project.NOM_PROYECTO.split(' ').join('-')+'?code='+quote.CODIGO, projectId: quote.project.ID_PROYECTO};
				return elem;
			});
		}).catch(() => {
			self.loading = false;
			self.items = []
		});
	},
	computed: {
		user() {
			return this.$auth.user();
		},
		rows() {
			return this.items.length
		}
	},
	methods: {
		canReserve(quote) {
			let days = Math.abs(new Date() - new Date(quote.FECHA_COTIZ)) / (60*60*24*1000)
			let validity = quote.quote_discounts.length > 0 ? quote.project.DIAS_VALIDEZ_COTIZACION_CON_DESCUENTO : quote.project.DIAS_VALIDEZ_COTIZACION;
			return (validity - days) >= 0 ? true : false
		},
	},
  }
</script>
<style>
</style>